import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="code-block"
// Wraps every <pre> inside the element with a header showing the language
// and a copy-to-clipboard button.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll("pre").forEach((pre) => this.decorate(pre));
  }

  decorate(pre) {
    if (pre.closest(".code-block")) return;

    const figure = document.createElement("figure");
    figure.className = "code-block";

    const head = document.createElement("div");
    head.className = "code-block__head";

    const language = document.createElement("span");
    language.textContent = this.languageOf(pre);

    const button = document.createElement("button");
    button.type = "button";
    button.className = "code-block__copy";
    button.textContent = "Copy";
    button.setAttribute("aria-label", "Copy code");
    button.addEventListener("click", () => this.copy(pre, button));

    head.append(language, button);
    pre.replaceWith(figure);
    figure.append(head, pre);
  }

  // Rouge renders <pre class="highlight ruby">; anything else is just "Code".
  languageOf(pre) {
    const tag = [...pre.classList].find((c) => c !== "highlight");
    if (!tag || tag === "plaintext") return "Code";
    return tag.charAt(0).toUpperCase() + tag.slice(1);
  }

  async copy(pre, button) {
    try {
      await navigator.clipboard.writeText(pre.innerText);
      button.textContent = "Copied";
    } catch (_error) {
      button.textContent = "Press ⌘C";
    }
    setTimeout(() => (button.textContent = "Copy"), 1600);
  }
}
